import * as types from './actionTypes';

export function sideMenuItemsSet(sideMenuItems: any) {
  return { type: types.SIDE_MENU_ITEMS_SET, sideMenuItems };
}
